import { Column } from "@bridgesplit/ui";

import { ExternalPointRewardStat } from "./ExternalPointReward";
import { GenericRewardsApyProps } from "../types";

export function RewardsExternalPointsRewards(props: GenericRewardsApyProps) {
    const { externalPointRewards } = props;

    if (!externalPointRewards) return null;

    return (
        <Column px={1.5} spacing={0.5}>
            {externalPointRewards.map((externalPointReward) => (
                <ExternalPointRewardStat
                    key={`external-point-reward-${externalPointReward}`}
                    externalPointReward={externalPointReward}
                />
            ))}
        </Column>
    );
}
